<template>
	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">

						<div class="row">
							<div class="col-sm-9 main">
								<!-- メインコンテンツ -->
								<div class="card pt-4 my-3">
									<div class="card-body p-2">
										<div class="card-text text-left text-muted">
											<div class="row p-0 m-0">
												<div class="col-sm-12">
													<h5 class="font-weight-bold p-0 m-0">{{ product['title'] }}</h5>
												</div>
											</div>
											<div class="row p-0 m-0">
												<div class="col-sm-12 mt-2">
													<span class="">{{ product['strong_point'] }}</span>
												</div>
											</div>
											<div class="row p-0 m-0">
												<div class="col-sm-12 mt-4" style="color: red;">
													<span class="">価格（税込み）: {{ number_format(Math.floor(product['price'] * 1.1)) }} 円</span>
												</div>
											</div>
											<div class="row p-0 m-0 mt-4">
												<div class="col-sm-6 d-flex align-items-center">
													<span class="pull-left h6 mr-3 mb-0" v-if="user['legal_person']==1">販売者： {{ user['corp_name'] }}</span>
													<span class="pull-left h6 mr-3 mb-0" v-else-if="user['legal_person']==0">販売者： {{ user['store_name'] }}</span>
					                                <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="user['evaluation']"></star-rating>
												</div>
											</div>
											<div class="row p-0 m-0">
												<div class="col-sm-12">
													<span class="">タイプ： {{ get_hash_value(type, product['type']) }}</span>
												</div>
											</div>
											<div class="row p-0 m-0">
												<div class="col-sm-12">
													<span class="">ブランド： {{ get_hash_value(brand, product['brand']) }}</span>
												</div>
											</div>
											<div class="row p-0 m-0">
												<div class="col-sm-12">
													<span class="">型番： {{ product['model_number'] }}</span>
												</div>
											</div>
											<div class="row p-0 m-0">
												<div class="col-sm-12">
													<span class="">商品の状態： {{ get_hash_value(state, product['state']) }}</span>
												</div>
											</div>
											<div class="row p-0 m-0">
												<div class="col-sm-12">
													<span class="">保管（展示）場所： {{ cinit(product['storage_location'], "-") }}</span>
												</div>
											</div>

											<div class="row p-0 m-0">
												<div class="col-sm-12 p-0">
													<div class="card p-1 py-3 m-1 mt-3" style="">
														<div class="main-img" style="padding: 10px;display: flex;align-items: center;">
															<img :src="mainImage1">
														</div>
														<template v-if="product_photo_count > 1">
															<hooper :itemsToShow="1.5" style="height: 100px">
																<slide v-for="n of product_photo_count" :key="n">
																	<img :src="product['image'+String(n)]" @click="mainChange1('image'+String(n))">
																</slide>
															</hooper>
														</template>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col-md-3 sidebar rounded">
								<div class="card my-3 py-0">
									<div class="card-body text-center text-muted py-5">
										<template v-if="String(product['status'])=='1'">
											<div class="row text-center">
												<div class="col-md-12">
													<a href="javascript:void(0);" @click="buyProduct()" style="font-size: 1rem;width: 100%;" class="m-0 p-3 btn btn-success">
														<span class="font-weight-bold">このピアノを購入する</span>
													</a>
												</div>
											</div>

											<div class="row text-center mt-4" v-show="String(common_products['about_test_bullet'])=='1'">
												<div class="col-md-12">
													<a href="javascript:void(0);" @click="testProduct()"  style="font-size: 1rem;width: 100%;" class="m-0 p-3 btn btn-info2">
														<span class="font-weight-bold">試弾の申し込みをする</span>
													</a>
												</div>
											</div>
										</template>
										<template v-if="String(product['status'])=='3'">
											<div class="row text-center mt-4">
												<div class="col-md-12">
													<a href="javascript:void(0);" style="font-size: 1rem;width: 100%;background-color: #817f83;color: white;" class="m-0 p-3 btn">
														<span class="font-weight-bold">売却済み</span>
													</a>
												</div>
											</div>
										</template>

										<div class="row text-center mt-4">
											<div class="col-md-12">
												<div class="balloon" @click="jumpComment">
													<p>コメント {{ allGetCommentCount }} 件</p>
												</div>
											</div>
										</div>

										<div class="row text-center mt-4">
											<div class="col-md-12">
												<a href="javascript:void(0);" @click="updFavorite()" style="border: solid 1px #a7a3a3;border-style: dashed;color: #575757;font-size: 1rem;width: 100%;background-color: #ffaef8!important;border-radius: 8px;" class="font-weight-bold m-0 p-3 btn btn-warning">
													<span class="heart" v-if="favorite">♥</span>
													<span class="heart" v-else>♡</span>
													お気に入り
												</a>
												<a href="javascript:void(0);" style="border: solid 1px #6a6a6a;color: #575757;font-size: 0.8rem;width: 100%;" class="m-0 mt-1 pl-1 pr-1 py-1 btn">
													<strong class="heart_count">{{ favoriteCount }}</strong>
													人がお気に入りに<br>登録しています
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">動画での商品紹介・演奏</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3" v-html="product['movie_tag']"></span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">動画紹介者、演奏者のコメント</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">{{ cinit(product['comment'], "-") }}</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">掲載日</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">{{ date_only_format(product['opened_at']) }}</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">価格</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">価格 {{ number_format(Math.floor(product['price'] * 1.1)) }} 円（税込）<br>{{ number_format(product['price']) }} 円</span>
							</div>
						</div>

						<div class="row m-0 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0 ml-2">この中古ピアノを提供する販売者</h5>

								<div class="row">
								<div class="col-md-3 sidebar rounded">
									<div class="card pt-3 my-3">
										<div class="card-body text-center text-muted">
											<div class="row">
												<div class="col-md-12">
													<div class="card-img-best-parent text-center center-block img-thumbnail" style="max-height: 200px;">
														<img class="card-img-best" :src="user_photos[0].image" alt="画像" @click="jumpSeller">
													</div>
												</div>
											</div>
											<div class="row mt-2">
												<div class="col-md-12 text-center">
													<h6 class="d-inline-block">
														<strong v-if="user['legal_person']==1">販売者： {{ user['corp_name'] }}</strong>
														<strong v-if="user['legal_person']==0">販売者： {{ user['store_name'] }}</strong>
													</h6>
													<span class="d-inline-block">
														{{ user['region'] + user['address_1'] }}
													<span>
												</div>
											</div>
											<div class="row my-3">
												<div class="col-md-12">
													<span class="d-inline-block">
														代表: {{ user['last_name'] + ' ' + user['first_name'] }}
													</span>
					                                <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="user['evaluation']"></star-rating>
												</div>
											</div>
											<div class="col-md-12 pr-3 pl-3">
												<div class="row">
													<div class="col-md-8 px-0">
													<span class="h6" style="font-size: 0.9rem;">現在販売中のピアノ台数</span>
													</div>
													<div class="col-md-4 px-0 pr-2 d-flex align-items-center text-right" style="font-size: 0.9rem;">
													<span class="" style="display: inline-block;width: 100%;font-size: 0.9rem;"> {{ user['now_sell_num'] }}</span>台
													</div>
												</div>
											</div>
											<div class="col-md-12 pr-3 pl-3">
												<div class="row">
													<div class="col-md-8 px-0">
													<span class="h6" style="font-size: 0.9rem;">過去に販売済みのピアノ台数</span>
													</div>
													<div class="col-md-4 px-0 pr-2 d-flex align-items-center text-right" style="font-size: 0.9rem;">
													<span class="" style="display: inline-block;width: 100%;font-size: 0.9rem;"> {{ user['sell_num'] }}</span>台
													</div>
												</div>
											</div>
											<div class="row text-center mt-3">
												<div class="col-md-12">
													<a href="javascript:void(0);" style="font-size: 1rem;width: 100%;" class="m-0 p-3 btn btn-success" @click="jumpSeller">
														<span class="font-weight-bold">販売中の中古ピアノ一覧を見る</span>
													</a>
												</div>
											</div>
											<div class="row text-center mt-2">
												<div class="col-md-12">
													<a href="javascript:void(0);" style="color: #575757;font-size: 1rem;width: 100%;border: solid 1px #9e9e9e;" class="font-weight-bold m-0 p-3 btn" @click="jumpMessageDetail(0)">問い合わせをする</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-sm-9 main">
									<div class="card my-3">
										<div class="card-body p-2">

											<div class="row p-0 m-0">
												<div class="col-sm-12 p-0">
													<div class="card p-1 py-3 m-1 mt-3" style="">
														<div class="main-img" style="padding: 10px;display: flex;align-items: center;">
															<img :src="mainImage2">
														</div>
														<template v-if="user_photos.length > 1">
															<hooper :itemsToShow="1.5" style="height: 100px">
																<slide v-for="n of user_photos.length" :key="n">
																	<img :src="user_photos[(n-1)].image" @click="mainChange2((n-1))">
																</slide>
															</hooper>
														</template>
													</div>
												</div>
											</div>
											<div class="m-3" id="counseling_ancer">
												<h6 class="font-weight-bold p-0 m-0">{{ user['slogan'] }}</h5>
												<div class="card-body text-muted p-2">
													<span>{{ user['Introduction'] }}</span>
												</div>
											</div>
											<div class="m-3" id="counseling_ancer">
												<h6 class="font-weight-bold p-0 m-0">購入された方への約束</h5>
												<div class="card-body text-muted p-2">
													<span>{{ user['promiss'] }}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								</div>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">商品スペック</h5>
								<span class="p-0 m-0 d-block my-4">
								 <div class="table-responsive">
								  <table class="p-table table-bordered" style="width: 100%;">
								  	<col width="25%" style="color: #6c6c6b;">
								  	<col width="25%" style="color: #6c6c6b;">
								  	<col width="25%" style="color: #6c6c6b;">
								  	<col width="25%" style="color: #6c6c6b;">
								    <tbody>
								  	  <tr></tr>
								  	  <tr>
								  	    <th>状態</th>
								  	    <td>{{ get_hash_value(state, product['state']) }}</td>
								  	    <th>製造番号</th>
								  	    <td>{{ cinit(product['make_number'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>タイプ</th>
								  	    <td>{{ get_hash_value(type, product['type']) }}</td>
								  	    <th>ペダル</th>
								  	    <td>{{ cinit(product['pedal'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>ブランド</th>
								  	    <td>{{ get_hash_value(brand, product['brand']) }}</td>
								  	    <th>鍵盤数</th>
								  	    <td>{{ cinit(product['keys_number'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>型番</th>
								  	    <td>{{ cinit(product['model_number'], "-") }}</td>
								  	    <th>製造場所</th>
								  	    <td>{{ cinit(product['make_place'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>サイズ</th>
								  	    <td>高さ{{ product['size_height'] }} × 幅{{ product['size_width'] }} × 奥行{{ product['size_depth'] }} cm</td>
								  	    <th>保証期間</th>
								  	    <td>{{ cinit(product['warranty_period'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>重量</th>
								  	    <td>{{ cinit(product['weight'], "-") }} Kg</td>
								  	    <th>展示（保管）場所</th>
								  	    <td>{{ cinit(product['storage_location'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>カラー</th>
								  	    <td>{{ get_hash_value(color, product['color']) }}</td>
								  	    <th></th>
								  	    <td></td>
								  	  </tr>
								  	  <tr>
								  	    <th>外装仕上げ</th>
								  	    <td>{{ cinit(product['exterior_finish'], "-") }}</td>
								  	    <th></th>
								  	    <td></td>
								  	  </tr>
								  	  <tr>
								  	    <th>製造年</th>
								  	    <td>{{ cinit(product['make_year'], "-") }} 年</td>
								  	    <th></th>
								  	    <td></td>
								  	  </tr>
								    </tbody>
								  </table>
								 </div>
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">このピアノの特徴</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ product['piano_feature'] }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">このピアノの状態</h5>
								<span class="ml-3 d-block mt-4">{{ get_hash_value(state, product['state']) }}</span>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ product['piano_status'] }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">整備したスタッフ、整備内容</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									<div class="row m-0 mt-5">
										<div class="col-md-12 m-0">
											<div class="row">
											<div class="col-md-3 sidebar rounded">
												<div class="card my-3">
													<div class="card-body text-center text-muted">
														<div class="row">
															<div class="col-md-12 mb-3">
																整備担当者: {{ product['manager_name'] }}
															</div>
															<div class="col-md-12">
																<div class="card-img-best-parent text-center center-block img-thumbnail" style="max-height: 200px;">
																	<img class="card-img-best" :src="user_photo_change(product['manager_image'])" alt="画像">
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="col-sm-9 main">
												<div class="card my-3">
													<div class="card-body p-2">
														<div class="m-3" id="counseling_ancer">
															<h6 class="font-weight-bold p-0 m-0">このピアノの整備でこだわったポイント</h5>
															<div class="card-body text-muted p-2">
																<span>{{ product['manager_point'] }}</span>
															</div>
														</div>
													</div>
												</div>
											</div>
											</div>
										</div>
									</div>
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<span class="p-0 m-0 d-block my-4">
								 <div class="table-responsive">
								  <table class="p-table table-bordered" style="width: 100%;">
								  	<col width="30%" style="color: #6c6c6b;">
								  	<col width="70%" style="color: #6c6c6b;">
								    <tbody>
								  	  <tr></tr>
								  	  <tr class="text-center">
								  	    <td colspan="2">整備内容（共通）</td>
									  </tr>
								  	  <tr>
								  	    <td colspan="2">{{ cinit(common_products['maintenance_policy'], "-") }}</td>
									  </tr>
								  	  <tr>
								  	    <th>外側の手入れ</th>
								  	    <td>{{ cinit(common_products['outer_care'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>内側の手入れ</th>
								  	    <td>{{ cinit(common_products['inner_care'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>内部の調整</th>
								  	    <td>{{ cinit(common_products['internal_adjustment'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>整調</th>
								  	    <td>{{ cinit(common_products['treasuring'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>整音</th>
								  	    <td>{{ cinit(common_products['sound_adjustment'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>調律</th>
								  	    <td>{{ cinit(common_products['tuning'], "-") }}</td>
								  	  </tr>
								  	  <tr>
								  	    <th>その他</th>
								  	    <td>{{ cinit(common_products['etc'], "-") }}</td>
								  	  </tr>
								    </tbody>
								  </table>
								 </div>
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">分割払い（<span style="color: red;">※共通情報</span>）</h5>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['whether_pay_installments'])=='1'">分割払い可</span>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['whether_pay_installments'])=='2'">分割払い不可</span>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['explanation_about_payment'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">付属品</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(product['accessories'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5" id="jump_comment">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<span class="p-0 m-0 d-block my-4">
									<div class="row m-0 mt-5">
										<div class="col-md-12 m-0">
											<div class="row">
											<div class="col-md-12 p-0">
												<div class="card my-3">
													<div class="card-body text-center text-muted">
														<div class="row">
															<div class="col-md-12">
																<p>
								                                <div class="d-flex">
																	<span class="mr-2" v-if="user['legal_person']==1">販売者： {{ user['corp_name'] }}</span>
																	<span class="mr-2" v-else-if="user['legal_person']==0">販売者： {{ user['store_name'] }}</span>
									                                <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="user['evaluation']"></star-rating>
																</div>
																</p>
																<hr>

																<hr>
																<p>コメント</p>
																<p>{{ allGetCommentCount }} 件</p>

																<div v-for="(comment, index) in allGetComments">
																	<div class="row px-3" v-show="index < dispCommentIndex">
																		<div class="col-2 pl-1 pr-1 m-0">
																			<img class="" :src="user_photo_change(comment['image'])" style="width: 100%;height: auto;">
																		</div>
																		<div class="col-10 pl-2 pr-0 m-0 text-left">
																			<p class="mb-2" style="font-size: 0.9rem;" v-if="String(comment['seller'])=='1'">代表: {{ comment['last_name'] + " " + comment['first_name'] }}</p>
																			<p class="mb-2" style="font-size: 0.9rem;" v-else>{{ comment['nickname'] }}</p>
																			<p class="mb-2">{{ comment['contents'] }}</p>
																			<p class="mb-2" style="font-size: 0.9rem;">{{ date_only_format(comment['created_at']) }}</p>
																		</div>
																	</div>
																	<hr v-show="index < dispCommentIndex">
																</div>
																<div class="row px-3" v-show="!all_disp_comment">
																	<hr>
																	<div class="col-12 text-center mt-3 mb-4" @click="allDispComment">
																		∇すべてのコメントを表示する
																	</div>
																</div>

																<p class="mb-2">商品へのコメント</p>
												                <textarea placeholder="コメントする" class="required form-control" rows="4" v-model="commentForm.contents" v-bind:class="{ error_input: commentForm.errors.contents.length > 0 }"></textarea>
																<div v-if="commentForm.errors.contents.length > 0">
																	<div class="error-text" v-for="(item, index) in commentForm.errors.contents" :key="index">{{ item }}</div>
																</div>
														        <button type="button" class="bs100 btn btn-primary mt-3" @click="sendComment">コメントを送信する</button>
															</div>
														</div>
													</div>
												</div>
											</div>
											</div>
										</div>
									</div>
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">契約後の流れ</h5>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">STEP1. ご注文</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									このページにある「このピアノを購入する」ボタンを押して注文いただきます。<br>
									ご注文確認後、お電話かメールをさせていただき、ご注文内容を確認いたします。
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">STEP2. お支払い</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['about_payment'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">STEP3. 出荷の準備</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['about_shipping_preparation'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">STEP4. 納品日と調律、調整の打合せ</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['delivery_date_appointment'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">STEP5. 納品と調律、調整作業</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['delivery_adjustment_work'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">STEP6. 購入について確認（サイト側からのお願い）</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									今回の購入について、納品された品物や購入額の確認をしていただきます。
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">STEP7. 評価（サイト側からのお願い）</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									今回の購入について、評価をお願いいたします。
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">万一のトラブルの際の対応について（<span style="color: red;">共通</span>）</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['response_case_trouble'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">販売できる地域について（<span style="color: red;">共通</span>）</h5>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['about_areas_sell'])=='1'">営業エリアのみ</span>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['about_areas_sell'])=='2'">全国通販可能</span>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['explanation_about_area'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">試弾について（<span style="color: red;">共通</span>）</h5>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['about_test_bullet'])=='1'">試弾可能</span>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['about_test_bullet'])=='2'">試弾不可</span>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['about_test_bullet'])=='1' && String(common_products['test_bullet_required'])=='1'">購入前に試弾必須</span>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['explanation_about_test_bullet'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">送料について（<span style="color: red;">共通</span>）</h5>
								<span class="ml-3 d-block mt-4">{{ number_format(common_products['postage']) }}円 ～</span>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['explanation_about_piano_installation'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">配送について（<span style="color: red;">共通</span>）</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['explanation_about_delivery'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">保証内容について（<span style="color: red;">共通</span>）</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['explanation_about_warranty_details'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">返品と交換について（<span style="color: red;">共通</span>）</h5>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['about_return'])=='1'">返品可能</span>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['about_return'])=='2'">返品不可</span>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['about_exchange'])=='1'">交換可能</span>
								<span class="ml-3 d-block mt-4" v-if="String(common_products['about_exchange'])=='2'">交換不可</span>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['explanation_about_return_exchange'], "-") }}
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">お支払いについて（<span style="color: red;">共通</span>）</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									【銀行振込】<br>
									振込手数料はお客様負担となります。尚、前払いとさせていただき、ご入金確認後の発送となります。<br>
									<br>
									【クレジットカード】
									<span v-if="String(common_products['credit_payment'])=='1'">可能</span>
									<span v-if="String(common_products['credit_payment'])=='2'">不可</span>
									<br>
									<br>
									【ジャックス　ショッピングクレジット】<br>
									ネットでお申し込みいただけます。最長10年<br>
									（120回払い）までご利用いただけます。<br>
									詳しくはお問合せください。<br>
								</span>
							</div>
						</div>

						<div class="row m-0 mr-2 ml-2 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
								<h5 class="font-weight-bold p-0 m-0">ご注意事項（<span style="color: red;">共通</span>）</h5>
								<span class="p-0 m-0 d-block my-4 ml-3 mr-3">
									{{ cinit(common_products['explanation_about_notes'], "-") }}
								</span>
							</div>
						</div>

						<template v-if="allGetSellerReviews.length > 0">
							<div class="row m-0 mr-2 ml-2 mt-5">
								<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
									<h5 class="font-weight-bold p-0 m-0">販売者へのレビュー</h5>
									<div v-for="(review, index) in allGetSellerReviews">
										<div class="row px-3 mt-5">
											<div class="col-2 pl-1 pr-1 m-0 d-flex justify-content-center">
												<img class="" :src="review['image1']" style="width: auto;max-height: 60px;">
											</div>
											<div class="col-10 pl-2 pr-0 m-0 text-left my-auto">
												<p class="mb-2" style="font-size: 0.9rem;">購入したピアノ {{ get_hash_value(brand, review['brand']) }} {{ review['model_number'] }}</p>
											</div>
										</div>
										<hr>
										<div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
											<div class="card-body row p-2 m-0">
												<div class="col-md-3 p-2 m-0" style="flex-flow: column;display: flex;align-items: center;justify-content: center;">
													<img class="" :src="user_photo_change(null)" style="width: 80%;height: auto;">
													<p>{{ review['old'] }}歳 {{ get_hash_value(gender, review['gender']) }}購入者</p>
													<p>{{ review['nickname'] }}さん</p>
												</div>
												<div class="card col-md-9 pl-0 pr-0 m-0" style="position: relative;">
													<div class="card-body">
														<div class="row mb-4">
															<div class="col-md-8 text-left d-flex">
																<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="review['evaluation']"></star-rating>
															</div>
															<span class="col-md-4 text-right">
																{{ date_only_format(review['created_at']) }}
															</span>
														</div>
														<p class="card-text mb-4">
															商品の満足度：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['product_evaluation'] }}</span>　
															掲載情報の正確性：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['infomation_evaluation'] }}</span>　
															スタッフの対応：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['staff_evaluation'] }}</span>　
															決済方法：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['payment_evaluation'] }}</span>　
															梱包：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['packing_evaluation'] }}</span>　
															配送：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['delivery_evaluation'] }}</span>
														</p>
														<p class="card-text mb-4" style="min-height: 140px;">
															<span class="">{{ review['contents'] }}</span>
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>

						<template v-if="allGetProductReviews.length > 0">
							<div class="row m-0 mr-2 ml-2 mt-5">
								<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">
									<h5 class="font-weight-bold p-0 m-0">商品へのレビュー</h5>
									<div v-for="(review, index) in allGetProductReviews">
										<div class="card col-md-12 pl-0 pr-0 m-0 mb-2 mt-5">
											<div class="card-body row p-2 m-0">
												<div class="col-md-3 p-2 m-0" style="flex-flow: column;display: flex;align-items: center;justify-content: center;">
													<img class="" :src="user_photo_change(null)" style="width: 80%;height: auto;">
													<p>{{ review['old'] }}歳 {{ get_hash_value(gender, review['gender']) }}購入者</p>
													<p>{{ review['nickname'] }}さん</p>
												</div>
												<div class="card col-md-9 pl-0 pr-0 m-0" style="position: relative;">
													<div class="card-body">
														<div class="row mb-4">
															<div class="col-md-8 text-left d-flex">
																<star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="review['evaluation']"></star-rating>
															</div>
															<span class="col-md-4 text-right">
																{{ date_only_format(review['created_at']) }}
															</span>
														</div>
														<p class="card-text mb-4">
															響き・音色：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['tone_evaluation'] }}</span>　
															タッチ感：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['touch_evaluation'] }}</span>　
															つくりの良さ：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['made_evaluation'] }}</span>　
															デザイン：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['design_evaluation'] }}</span>　
															維持・管理のしやすさ：<span style="color: rgb(250 241 52);font-weight: bold;">{{ review['maintain_evaluation'] }}</span>
														</p>
														<p class="card-text mb-4">
															このピアノを使う人：<span style="font-weight: bold;">{{ get_hash_value(who_use, review['who_use']) }}</span>　
															このピアノの使い方：<span style="font-weight: bold;">{{ get_hash_value(how_use, review['how_use']) }}</span>　
														</p>
														<p class="card-text mb-4" style="min-height: 140px;">
															<span class="">{{ review['contents'] }}</span>
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>

					</div>

				</div>
			</div>

		</b-container>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Hooper, Slide } from 'hooper';
import StarRating from 'vue-star-rating'

export default {
	name: 'ProductDetail',
    components: {
      Hooper,
      Slide,
	  'star-rating': StarRating,
    },
	data () {
		const gender = [
			{"no":"1","name":"男性"},
			{"no":"2","name":"女性"},
		];
		const state = [
			{"no":"1","name":"新古品"},
			{"no":"2","name":"中古品（非常に良い）"},
			{"no":"3","name":"中古品（良い）"},
			{"no":"4","name":"中古品（あまり良くない）"},
			{"no":"5","name":"中古品（悪い）"},
		];
		const type = [
			{"no":"1","name":"グランドピアノ（GP）"},
			{"no":"2","name":"アップライトピアノ（UP）"},
	    ];
		const brand = [
			{"no":"1","name":"ヤマハ（YAMAHA）"},
			{"no":"2","name":"カワイ（KAWAI）"},
			{"no":"3","name":"スタインウェイ・アンド・サンズ　（Steinway&Sons）"},
			{"no":"4","name":"ベーゼンドルファー　（Bösendorfer）"},
			{"no":"5","name":"ベヒシュタイン　（BECHSTEIN）"},
			{"no":"6","name":"ボストン　（BOSTON）"},
			{"no":"7","name":"ディアパソン　（DIAPASON）"},
			{"no":"8","name":"アポロ　（APOLLO）"},
			{"no":"9","name":"国産ピアノ"},
			{"no":"10","name":"輸入ピアノ"},
	    ];
		const color = [
			{"no":"1","name":"黒"},
			{"no":"2","name":"木目"},
			{"no":"3","name":"白"},
			{"no":"4","name":"その他"},
	    ];
		const who_use = [
      		{"no":"1","name":"子供"},
			{"no":"2","name":"大人"},
			{"no":"3","name":"家族共用"},
			{"no":"4","name":"演奏家"},
			{"no":"5","name":"生徒"},
			{"no":"6","name":"不特定多数"},
			{"no":"7","name":"その他"},
		];
		const how_use = [
      		{"no":"1","name":"普段用"},
			{"no":"2","name":"ピアノレッスン用"},
			{"no":"3","name":"サロン演奏用"},
			{"no":"4","name":"コンサートホールなど公共施設用"},
			{"no":"5","name":"その他"},
		];
		return {
			gender,
			state,
			type,
			brand,
			color,
			who_use,
			how_use,

			products_id: null,
			product: null,
			product_photo_count: 0,
			my_user: null,
			my_user_photos: null,
			user: null,
			user_photos: null,
			common_products: null,
			product_comments: null,

			// お気に入り
			favoriteCount: 0,
			favorite: false,

			seller_review: [],
			product_review: [],

			now_sell_product_count: 0,
			back_sell_product_count: 0,

			isError: true,
			commentForm: {
				errors: {
					contents: [],
				},
				contents: "",
			},

			disp_comment_index: 4,
			all_disp_comment: false,

			main_image1: null,
			main_image2: null,

		}
	},
	methods: {
	  buyProduct() {
	    if ( this.login_check(this.token) ) {
		  this.$router.push({path: '/buy/'+this.products_id});
		}
		return false;
	  },
	  testProduct() {
	    if ( this.login_check(this.token) ) {
		  this.$router.push({path: '/test_bullet/'+this.products_id});
		}
		return false;
	  },
	  updFavorite() {
	    if ( this.login_check(this.token) ) {
		  this.upd_favorite();
		}
		return false;
	  },
	  sendComment() {
	    if ( this.login_check(this.token) ) {
		  this.isError = false;
		  this.commentForm.errors.contents = [];
		  if (!this.commentForm.contents) {
			this.commentForm.errors.contents.push('コメントが入力されていません');
			this.isError = true;
		  }
		  if (!this.isError) {
		    this.send_comment();
		  }
		}
		return false;
	  },
	  jumpComment() {
        document.getElementById("jump_comment").scrollIntoView(true)
	  },
	  jumpSeller() {
        this.$router.push({path: '/seller/'+this.user.id});
	  },
	  allDispComment() {
		this.all_disp_comment = true;
		this.disp_comment_index = 10000;
	  },
      // お気に入り更新処理
      async upd_favorite() {
        this.$store.dispatch('product/upd_favorite', {
          type: 1,
          products_id: this.products_id,
          sellers_id: this.user.id,
        //   users_id: this.,
        }).then(res => {
          console.log(res);
		  this.favorite = !this.favorite;
		  if(this.favorite){
			this.favoriteCount++;
		  }else {
			this.favoriteCount--;
		  }
          return false;
        }, error => {
          // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
          console.log(error.response.data);
          if ('error' in error.response.data) {
            alert(error.response.data['error']);
            window.scrollTo({
              top: 0,
            });
          }
        });
        return false;
      },
      // コメント送信処理
      async send_comment() {
        this.$store.dispatch('product/send_comment', {
		  product_comments_id: null,
		  delete: false,
          contents: this.commentForm.contents,
          products_id: this.products_id,
        //   users_id: this.,
        }).then(res => {
          console.log(res);
		  let image = "", seller = 0;
		  if ( this.my_user_photos != null ) {
			image = this.my_user_photos.image;
		  }
		  if ( this.product.users_id == this.my_user.id ) {
			seller = 1;
		  }
		  this.product_comments.push({
			  image: image,
			  contents: this.commentForm.contents,
			  nickname: this.my_user.nickname,
			  corp_name: this.my_user.corp_name,
			  store_name: this.my_user.store_name,
			  last_name: this.my_user.last_name,
			  first_name: this.my_user.first_name,
			  seller: seller,
			  created_at: "",
		  })
		  this.commentForm.contents = "";
          return false;
        }, error => {
          // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
          console.log(error.response.data);
          if ('error' in error.response.data) {
            alert(error.response.data['error']);
            window.scrollTo({
              top: 0,
            });
          }
        });
        return false;
      },
	  // this.$route.params.products_id
	  async get_product_detail(id) {
		this.$store.dispatch('product/get_product_detail', {
          id: id,
        }).then(res => {
		  console.log(res);
		  let ret = res.data.product;
		  this.product = ret['product'];
		  if ( this.product['image1'] != null ) {
			this.product_photo_count++;
			this.main_image1 = this.product['image1'];
		  }
		  if ( this.product['image2'] != null ) {
			this.product_photo_count++;
		  }
		  if ( this.product['image3'] != null ) {
			this.product_photo_count++;
		  }
		  if ( this.product['image4'] != null ) {
			this.product_photo_count++;
		  }
		  if ( this.product['image5'] != null ) {
			this.product_photo_count++;
		  }
		  if ( this.product['image6'] != null ) {
			this.product_photo_count++;
		  }
		  if ( this.product['image7'] != null ) {
			this.product_photo_count++;
		  }
		  if ( this.product['image8'] != null ) {
			this.product_photo_count++;
		  }
		  if ( this.product['image9'] != null ) {
			this.product_photo_count++;
		  }
		  if ( this.product['image10'] != null ) {
			this.product_photo_count++;
		  }
		  this.user = ret['user'];
		  this.my_user = ret['my_user'];
		  this.my_user_photos = ret['my_user_photos'];
		  this.user_photos = ret['user_photos'];
		  if ( this.user_photos.length > 0 ) {
		    this.main_image2 = this.user_photos[0].image;
		  }
		  this.common_products = ret['common_products'];
		  this.favorite = ret['favorite'];
		  this.favoriteCount = ret['favorite_count'];
		  this.product_comments = ret['product_comments'];
		  this.seller_review = ret['seller_review'];
		  this.product_review = ret['product_review'];
		  if ( this.product_comments.length < 5 ) {
			  this.all_disp_comment = true;
		  }
		  console.log(this.product);
		  console.log(this.user);
		  console.log(this.my_user);
		  console.log(this.my_user_photos);
		  console.log(this.user_photos);
		  console.log(this.common_products);
		  console.log(this.favorite);
		  console.log(this.favoriteCount);
		  console.log(this.product_comments);
		  if( this.$route.query.anc != null && this.$route.query.anc != undefined && String(this.$route.query.anc) != "" ){
			this.$nextTick(function() {
				document.getElementById(this.$route.query.anc).scrollIntoView(true)
			});
		  }
		}, error => {
		  console.log('error発生');
		  console.log(error);
		  this.$nextTick(() => {
            window.scrollTo({
              top: 0,
            });
		  });
	    });
	  },

	  mainChange1(key) {
		this.main_image1 = this.product[key];
	  },
	  mainChange2(key) {
		this.main_image2 = this.user_photos[key].image;
	  },

	  jumpMessageDetail: function(status){
        this.$router.push({path: '/message/'+String(this.user.id)+'/'+String(status)+'/0'});
	  },

	},
	created() {
		this.products_id = this.$route.params.products_id;
		this.get_product_detail(this.products_id);
	},
	mounted() {
		if( this.$route.query.anc != null && this.$route.query.anc != undefined && String(this.$route.query.anc) != "" ){
			this.$nextTick(function() {
				document.getElementById(this.$route.query.anc).scrollIntoView(true)
			});
		}
	},
	computed: {
		...mapState('auth', ['token']),
		token: function() {
			return this.$store.getters["auth/token"];
		},
    // isMypage() {
    //   return location.pathname.indexOf("mypage")!=-1;
    // }
		allGetProductReviews: function() {
			return this.product_review;
		},
		allGetSellerReviews: function() {
			return this.seller_review;
		},
		allGetComments: function() {
			return this.product_comments;
		},
		allGetCommentCount: function() {
			return this.product_comments.length;
		},
		dispCommentIndex: function() {
			return this.disp_comment_index;
		},

		mainImage1: function() {
			return this.main_image1;
		},
		mainImage2: function() {
			return this.main_image2;
		},

	},
}
</script>

<style scoped>
.hooper-slide {
	width: 150px!important;
    display: flex!important;
    align-items: center!important;
	padding: 10px!important;
    border: solid 1px #c9c9c9!important;
    margin: 0px 2px!important;
    border-radius: 6px!important;
	overflow: hidden!important;
}
.vue-star-rating {
	justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductDetail.vue